export default __webpack_public_path__ + "static/media/how-image.cf1152e8.svg";